<template>
  <div>
    <div class="row text-left">
      <div class="col-12" v-loading="parent.loadingTabelaPreco">
        <el-tabs type="border-card" v-model="parent.tabHistorico">
          <el-tab-pane label="Credenciadas" name="tab-credenciada">
            <span slot="label"
              ><i class="fa fa-address-card"></i> Credenciadas</span
            >

            <label v-if="!parent.formData.id_tipo_aso"
              >Selecione o Tipo de Consulta</label
            >
            <label v-else-if="!parent.tabela_preco">Aguarde...</label>
            <span
              v-else-if="parent.tabela_preco && parent.tabela_preco.total == 0"
            >
              <ed-alert
                type="error"
                :description="
                  'Por favor entre em contato conosco no telefone ' +
                  cliente.logged.tel_com +
                  ' para maiores informações'
                "
                title="Nenhuma credenciada encontrado"
              />
            </span>

            <span
              class="col-12"
              v-else-if="parent.tabela_preco && !Array.isArray(parent.tabela_preco)"
            >
              <ed-alert
                type="error"
                :description="parent.tabela_preco"
                title="Falha ao Carregar as Credenciadas"
              />
            </span>
            <span v-else>
              <div class="row">
                <div
                  class="col-12 mb-3"
                  v-if="parent.tabela_preco && parent.tabela_preco"
                >
                  <ed-alert
                    type="warning"
                    description="Para continuar com o cadastro do ASO você deve selecionar a Credenciada. Você tambem pode utilizar os filtros ao lado para buscar alguma credenciada próximo do seu local."
                    title="Atenção"
                  />
                </div>
                <div
                  class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 q-pa-xs"
                  v-if="parent.tabela_preco && parent.tabela_preco"
                >
                  <div class="col-12 q-mb-md" style="color: #21ba45">
                    {{ parent.tabela_preco.total }}
                    <label v-if="parent.tabela_preco.total == 1"
                      >credenciada encontrado</label
                    >
                    <label v-if="parent.tabela_preco.total > 1"
                      >credenciadas encontrado</label
                    >
                  </div>

                  <!--ORGANIZAR-->
                  <div
                    class="col-12 mb-3"
                    v-if="parent.tabela_preco && parent.tabela_preco"
                  >
                    <span class="credenciada-title"
                      >Organizar Credenciadas</span
                    >
                    <el-select
                      v-model="parent.formFilter.order"
                      placeholder="Selecione"
                    >
                      <el-option
                        v-for="item in lstOrganizar"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <!--ESTADO-->
                  <div
                    class="col-12 mb-3"
                    v-if="parent.tabela_preco && parent.tabela_preco"
                  >
                    <span class="credenciada-title">Estado</span>
                    <el-select
                      v-model="parent.formFilter.id_estado"
                      placeholder="Selecione"
                      @change="getCidade"
                    >
                      <el-option
                        v-for="item in estados"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <!--CIDADE-->
                  <div
                    class="col-12 mb-3"
                    v-if="parent.tabela_preco && parent.tabela_preco"
                  >
                    <span class="credenciada-title">Cidade</span>
                    <el-select
                      v-model="parent.formFilter.id_cidade"
                      placeholder="Selecione"
                      :disabled="!parent.formFilter.id_estado"
                    >
                      <el-option
                        v-for="item in cidades"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
                  <div class="row">
                    <div
                      class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 card-item"
                      v-for="(tabela_preco, i) in parent.tabela_preco"
                      :key="i"
                    >
                      <el-card
                        :class="
                          'box-card col-md-12 mb-3' +
                          (parent.formData.id_tabela_preco == tabela_preco.id
                            ? ' box-card-selected'
                            : '')
                        "
                        shadow="hover"
                      >
                        <div slot="header" class="clearfix">
                          <!-- <span style="float: right;" v-if="tabela_preco.credenciada_email">
                            <el-rate 
                              v-model="tabela_preco.credenciada_rate" 
                              disabled 
                              :title="(tabela_preco.credenciada_rate == null ? 'Essa credenciada ainda não foi avaliada' : 'Nota de Avaliação: '+tabela_preco.credenciada_rate)"
                              text-color="#ff9900"
                              :score-template="(tabela_preco.credenciada_rate == null ? 'Sem Avaliação' : 'Nota {value}')"
                            />
                          </span> -->
                          <span>
                            <el-radio
                              v-model="parent.formData.id_tabela_preco"
                              :val="tabela_preco.id"
                              :label="tabela_preco.id"
                              :title="tabela_preco.credenciada_nome"
                            >
                              <b>{{
                                textLimit(tabela_preco.credenciada_nome, 50)
                              }}</b>
                            </el-radio>

                            <div style="font-size: 9pt">
                              <i class="fas fa-map-marker-alt" />
                              {{ tabela_preco.credenciada_end.toUpperCase() }},
                              {{ tabela_preco.credenciada_num }}
                              <span v-if="tabela_preco.credenciada_cidade">
                                -
                                {{
                                  tabela_preco.credenciada_cidade.toUpperCase() +
                                  "/" +
                                  tabela_preco.credenciada_uf.toUpperCase()
                                }}
                              </span>
                            </div>

                            <div
                              class="text-center item"
                              style="margin-top: 10px"
                            >
                              <label style="font-size: 35px">
                                {{
                                  "R$" +
                                  getPreco(tabela_preco.valor_total, "unit")
                                }}
                              </label>
                              <label style="font-size: 25px">
                                <sup>
                                  {{
                                    getPreco(tabela_preco.valor_total, "cents")
                                  }}
                                </sup>
                              </label>
                              <label style="font-size: 10px">
                                <br />Valor por cada ASO<br>
                                <span style="color:red">Esses valores podem sofrer alteração, devido a validade dos exames complementares.</span>
                              </label>
                            </div>
                          </span>
                        </div>
                        <!--ITENS-->

                        <div class="text item q-mb-sm pa-1" style="font-size: 9pt;background:#d7eaf4" v-if="tabela_preco.exames.mascaramento<0">
                          <b>Mascaramento</b>
                        </div>

                        <div class="text item" style="font-size: 9pt" v-if="tabela_preco.exames.mascaramento<0">
                          <i class="far fa-hand-point-right" />
                          O mascaramento está habilitado: Os exames serão carregados {{Math.abs(tabela_preco.exames.mascaramento)}} dia(s) antes do vencimento configurado no PCMSO.
                          
                        </div>

                        <div class="text item q-mb-sm mt-1 pa-1" style="font-size: 9pt;background:#d7eaf4">
                          <b>Exames</b>
                        </div>

                        <div class="text item" style="font-size: 9pt">
                          <i class="far fa-hand-point-right" />
                          Total: {{ tabela_preco.total_exames }}<br>
                          Total Pendente: {{ tabela_preco.total_exames_realizar }}<br>
                        </div>


                        <div class="text item text-center q-mt-lg mt-2">
                          <ed-button
                            size="mini"
                            value=" Ver Exames"
                            type="default"
                            icon="fa fa-search"
                            @click="onShowExame(tabela_preco)"
                          />
                        </div>
                      </el-card>
                    </div>

                    <!-- <div class="col-12 mt-5 text-center">
                      <ed-paginate
                        :pagination="parent.tabela_preco"
                        :navigation="parent.getCredenciada"
                      />
                    </div> -->
                  </div>
                </div>
                <!--CREDENCIADA LIST-->
              </div>
              <Exame
                :parent="this"
                :tabela_preco="tabela_preco"
                :showExame="showExame"
              /> </span
            ><!-- TABELA DE PRECO!-->
          </el-tab-pane>

          <el-tab-pane label="Exames no PCMSO" name="tab-pcmso">
            <span slot="label"
              ><i class="fa fa-user-md"></i> Exames no PCMSO</span
            >
            <div class="col-12">
              <ed-alert
                class="mb-3"
                type="warning"
                description="Na tabela abaixo você pode conferir os exames cadastrados no PCMSO. Esses exames estão vinculados diretamente com o GHE (Setor) seleciona acima."
                title="Atenção"
              />
              <Pcmso :id_ghe="parent.formData.id_ghe" />
            </div>
          </el-tab-pane>

          <el-tab-pane label="Histórico de Consultas" name="tab-historico">
            <span slot="label"
              ><i class="fa fa-clock-o"></i> Histórico de Consultas</span
            >
            <span>
              <Historico
                :funcionario="parent.formData.funcionario"
                :id_funcao="parent.formData.id_funcao"
              />
            </span>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdPaginate from "common/paginate";
import EdAlert from "common/alert";
import EdButton from "common/button";

import Pcmso from "appsEmpresa/consulta/_includes/pcmso";
import Historico from "appsEmpresa/consulta/_includes/historico";
import Exame from "./exame";

export default {
  name: "EmpresaCadastro",
  components: { EdPaginate, EdAlert, EdButton, Pcmso, Historico, Exame },
  mixins: [Rest],
  props: {
    parent: {
      type: Object,
      default: {},
    },
  },
  watch: {
    parent() {},
    "parent.formData.tabHistorico"() {},
    "parent.formData.id_tabela_preco"() {},
    "parent.formData.id_funcao"() {},
    "parent.formData.id_ghe"() {},
    "parent.formData.id_mf_ghe"() {},
    "parent.formData.funcionario"() {},
    "parent.loadingTabelaPreco"() {},
    "parent.tabela_preco": {
      deep: true,
      handler() {
        this.inicialize();
      },
    },
  },

  data() {
    return {
      showExame: false,
      loadingExame: false,
      tabela_preco: null,
      lstOrganizar: [
        { value: "ate_cli_cre.nome", label: "Nome" },
        { value: "ate_cli_cre.rate", label: "Mais Relevantes" },
      ],
      filtros: [],
      estados: [],
      cidades: [],
      tipo_tabela_preco: [],
    };
  },
  created() {},
  mounted() {},

  methods: {
    inicialize() {
      if (this.parent.tabela_preco && this.parent.tabela_preco.length) {
        this.getEstado();
      }
    },

    onChangeParceiro(tabela_preco, item) {
      var valor = 0,
        valor_total = 0,
        valor_servico = 0,
        exames = [];

      for (let i = 0; i < this.tabela_preco.exames.consulta.length; i++) {
        const tabela_preco = this.tabela_preco.exames.consulta[i];

        for (let j = 0; j < tabela_preco.parceiros.length; j++) {
          if (tabela_preco.id_par == tabela_preco.parceiros[j].parceiro.id) {
            const parceiro = tabela_preco.parceiros[j];

            valor += this.moneyToFloat(parceiro.valor);
            valor_servico += this.moneyToFloat(parceiro.valor_servico);
            valor_total += this.moneyToFloat(parceiro.valor_total);

            this.tabela_preco.exames.consulta[i].valor_venda = parceiro.valor;
            this.tabela_preco.exames.consulta[i].valor_servico =
              parceiro.valor_servico;
            this.tabela_preco.exames.consulta[i].valor_total =
              parceiro.valor_total;

            exames.push({
              id_exa: tabela_preco.exame.id,
              id_par: tabela_preco.id_par,
            });
          }
        }
      }

      this.tabela_preco.valor = this.floatToMoney(valor);
      this.tabela_preco.valor_total = this.floatToMoney(valor_total);
      this.tabela_preco.valor_servico = this.floatToMoney(valor_servico);

      this.parent.formData.exames = exames;

      for (let i = 0; i < this.parent.tabela_preco.length; i++) {
        if (this.parent.tabela_preco[i].id == this.tabela_preco.id) {
          this.parent.tabela_preco[i].valor = this.tabela_preco.valor;
          this.parent.tabela_preco[
            i
          ].valor_total = this.tabela_preco.valor_total;
          this.parent.tabela_preco[
            i
          ].valor_servico = this.tabela_preco.valor_servico;
        }
      }
    },

    onShowExame(tabela_preco) {
      this.tabela_preco = tabela_preco;
      this.showExame = !this.showExame;
      this.loadingExame = true;

      var filter = {
        id_exa: [],
      };

      for (let i = 0; i < this.tabela_preco.exames.consulta.length; i++) {
        filter.id_exa.push(this.tabela_preco.exames.consulta[i].exame.id);
      }

      this.get("tabela-preco/exame/" + this.tabela_preco.id, {
        filter: filter,
      }).then((result) => {
        result = result[0];

        this.loadingExame = false;

        if (result.status == 200) {
          var data = result.data.data;

          for (let i = 0; i < this.tabela_preco.exames.consulta.length; i++) {
            const elementi = this.tabela_preco.exames.consulta[i];

            this.tabela_preco.exames.consulta[i].parceiros = [];

            for (let j = 0; j < data.length; j++) {
              const elementj = data[j];

              if (elementi.exame.id == elementj.exame.id) {
                this.tabela_preco.exames.consulta[i].parceiros =
                  elementj.exames_parceiro;
              }
            }
          }
        }
      });
    },

    getEstado() {
      var tabela_preco = this.parent.tabela_preco;
      this.estados = [];

      var estados = [
        {
          value: null,
          label: "Todos",
        },
      ];

      for (let i = 0; i < tabela_preco.length; i++) {
        const element = tabela_preco[i];

        if (!element.credenciada_uf) continue;

        if (
          !this.arrFindByField(this.estados, "value", element.credenciada_uf)
        ) {
          this.estados.push({
            value: element.credenciada_uf,
            label: element.credenciada_estado,
          });
        }
      }

      this.estados = this.estados.sort((a, b) =>
        a.label > b.label ? 1 : b.label > a.label ? -1 : 0
      );
      this.estados = estados.concat(this.estados);

      this.getCidade();
    },

    getCidade() {
      var tabela_preco = this.parent.tabela_preco;

      this.cidades = [];
      var cidades = [
        {
          value: null,
          label: "Todos",
        },
      ];

      if (!this.parent.formFilter.id_estado) {
        cidades = [
          {
            value: null,
            label: "Selecione o Estado",
          },
        ];
        this.parent.formFilter.id_cidade = null;
        return;
      }

      for (let i = 0; i < tabela_preco.length; i++) {
        const element = tabela_preco[i];

        if (!element.credenciada_cidade) continue;

        if (
          !this.arrFindByField(
            this.cidades,
            "value",
            element.credenciada_cidade
          )
        ) {
          this.cidades.push({
            value: element.credenciada_cidade_id,
            label: element.credenciada_cidade,
            disable: !this.parent.formFilter.id_estado ? true : false,
          });
        }
      }

      this.cidades = this.cidades.sort((a, b) =>
        a.label > b.label ? 1 : b.label > a.label ? -1 : 0
      );
      this.cidades = cidades.concat(this.cidades);
    },
  },
};
</script>

<style lang="scss">
.card-item .box-card:hover {
  cursor: pointer;
  border: solid 1px #31ccec !important;
}
.box-card-btn {
  float: right;
  padding: 5px;
}

.card-item .box-card:hover {
  cursor: pointer;
  border: solid 1px #31ccec !important;
}
.box-card-selected {
  border: solid 1px #21ba45 !important;
}

.credenciada-title {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// index.vue?157f3f1b